import { ref, watch } from 'vue'

/**
 * 桌面宠物(电子宠物)开关 —— 模块级 ref,侧栏入口与 DesktopPet 组件共享同一份
 * (同 useSupport 写法)。开了就有只小动物在窗口底边遛,点它弹气泡接 iris 聊天。
 *
 * 偏好持久化到 localStorage:开/关 + 形象(MVP 只有螃蟹,留 kind 扩展位,
 * 多形象时「系统设置」再加选择器)。默认关闭 —— 商用工具,opt-in 不打扰。
 */
export type PetKind = 'crab'

const STORAGE_KEY = 'fabric.pet'

function load(): { enabled: boolean; kind: PetKind } {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      const o = JSON.parse(raw) as { enabled?: unknown; kind?: unknown }
      return { enabled: !!o.enabled, kind: (o.kind as PetKind) || 'crab' }
    }
  } catch {
    /* 坏数据 → 用默认 */
  }
  return { enabled: false, kind: 'crab' }
}

const init = load()
const petEnabled = ref<boolean>(init.enabled)
const petKind = ref<PetKind>(init.kind)

watch([petEnabled, petKind], () => {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ enabled: petEnabled.value, kind: petKind.value })
    )
  } catch {
    /* 隐私模式 / 配额满 → 忽略,内存态仍可用 */
  }
})

export function usePet() {
  return {
    petEnabled,
    petKind,
    togglePet() {
      petEnabled.value = !petEnabled.value
    }
  }
}
